"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyKeys = exports.fonts = exports.TypographyKeys = exports.BASE_FONT_FAMILY = void 0;
let TypographyKeys;
exports.TypographyKeys = TypographyKeys;

(function (TypographyKeys) {
  TypographyKeys["Header1"] = "header1";
  TypographyKeys["Header2"] = "header2";
  TypographyKeys["Header3"] = "header3";
  TypographyKeys["Header4"] = "header4";
  TypographyKeys["BodyText1"] = "bodyText1";
  TypographyKeys["BodyText2"] = "bodyText2";
  TypographyKeys["BodyText3"] = "bodyText3";
  TypographyKeys["BodyText4"] = "bodyText4";
  TypographyKeys["BodyText5"] = "bodyText5";
  TypographyKeys["BodyText6"] = "bodyText6";
  TypographyKeys["SmallCaps1"] = "smallCaps1";
  TypographyKeys["SmallCaps2"] = "smallCaps2";
  TypographyKeys["SmallCaps3"] = "smallCaps3";
})(TypographyKeys || (exports.TypographyKeys = TypographyKeys = {}));

const BASE_LETTER_SPACING = '0.015625em';
const BASE_FONT_FAMILY = '"Lato", Helvetica, Arial, sans-serif';
exports.BASE_FONT_FAMILY = BASE_FONT_FAMILY;
const bodyTextBase = {
  fontFamily: BASE_FONT_FAMILY,
  fontWeight: 500,
  letterSpacing: BASE_LETTER_SPACING
};
const smallCapsBase = {
  fontFamily: BASE_FONT_FAMILY,
  fontWeight: 500,
  letterSpacing: '0.125rem',
  textTransform: 'uppercase'
};
const fonts = {
  header1: {
    fontFamily: BASE_FONT_FAMILY,
    fontWeight: 900,
    fontSize: '3rem',
    letterSpacing: BASE_LETTER_SPACING
  },
  header2: {
    fontFamily: BASE_FONT_FAMILY,
    fontWeight: 900,
    fontSize: '2rem',
    letterSpacing: BASE_LETTER_SPACING
  },
  header3: {
    fontFamily: BASE_FONT_FAMILY,
    fontWeight: 700,
    fontSize: '1.5rem',
    letterSpacing: `2 * ${BASE_LETTER_SPACING}`
  },
  header4: {
    fontFamily: BASE_FONT_FAMILY,
    fontWeight: 700,
    fontSize: '1.125rem',
    letterSpacing: `2 * ${BASE_LETTER_SPACING}`
  },
  bodyText1: { ...bodyTextBase,
    fontSize: '2rem'
  },
  bodyText2: { ...bodyTextBase,
    fontSize: '1.125rem'
  },
  bodyText3: { ...bodyTextBase,
    fontSize: '1rem'
  },
  bodyText4: { ...bodyTextBase,
    fontSize: '0.875rem'
  },
  bodyText5: { ...bodyTextBase,
    fontSize: '0.75rem',
    letterSpacing: `2 * ${BASE_LETTER_SPACING}`
  },
  bodyText6: { ...bodyTextBase,
    fontSize: '0.625rem',
    letterSpacing: `2 * ${BASE_LETTER_SPACING}`
  },
  smallCaps1: { ...smallCapsBase,
    fontSize: '0.875rem'
  },
  smallCaps2: { ...smallCapsBase,
    fontSize: '0.75rem'
  },
  smallCaps3: { ...smallCapsBase,
    fontSize: '0.625rem'
  },
  bold: {
    fontWeight: 700
  }
};
exports.fonts = fonts;
const typographyKeys = Object.keys(fonts);
exports.typographyKeys = typographyKeys;